import { ADD_LOT } from '../../constants';

const initialState = {
  data: [],
  loading: false,
  error: {}
};

export default function (state = initialState, { type, payload } = {}) {
  switch (type) {
    case ADD_LOT.LOAD:
      return {
        ...state,
        loading: true
      };
    case ADD_LOT.SUCCESS:
      return {
        ...state,
        data: payload,
        loading: false
      };
    case ADD_LOT.FAIL:
      return {
        ...state,
        error: payload,
        loading: false
      };
    default:
      return state;
  }
}
